var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.7,
    height: 41.7,
    viewBox: "0 0 41.7 41.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 41.7,
    height: 41.7,
    rx: 10,
    ry: 10,
    fill: "#95be72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.69,28.64c-1.25,0-2.58-.35-3.92-1.07l.2-.37c2.97,1.59,5.86,1.3,7.94-.77,3.37-3.37,4.34-8.58,2.75-14.71-3.13,1.02-5.77,1.16-7.9,1.27-2.67.14-4.78.26-6.51,1.98-1.5,1.5-2.14,3.19-1.91,5.03.21,1.7,1.19,3.46,2.81,5.08l-.29.29c-1.69-1.69-2.71-3.53-2.93-5.33-.25-1.95.45-3.81,2.03-5.38,1.84-1.84,4.02-1.96,6.78-2.1,2.26-.12,4.83-.26,8-1.32l.21-.07.06.21c1.71,6.37.72,11.81-2.8,15.33-1.27,1.27-2.83,1.91-4.51,1.91Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.76,30.3c-.91-3.99,2.57-6.99,6.25-10.17,1.06-.92,2.16-1.87,3.19-2.87l.29.3c-1.04,1.01-2.14,1.96-3.21,2.89-3.74,3.23-6.96,6.02-6.11,9.76l-.41.09Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.64,22.95l-.17-.38c.05-.02,1.31-.59,3.6-.31l-.05.41c-2.16-.26-3.36.27-3.38.28Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.33,20.94l-.38-.18s.57-1.25.55-2.47h.42c.03,1.31-.56,2.59-.59,2.64Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.85,37.29c-9.07,0-16.44-7.38-16.44-16.44S11.79,4.41,20.85,4.41s16.44,7.38,16.44,16.44-7.38,16.44-16.44,16.44Zm0-32.46c-8.84,0-16.02,7.19-16.02,16.02s7.19,16.02,16.02,16.02,16.02-7.19,16.02-16.02S29.69,4.83,20.85,4.83Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c5ea919df6e99e1381e0b47addbedf4f.svg";
export { ForwardRef as ReactComponent };